import { useChartsContext } from '@/context/chartsThemeContext';
import {
    EChartsOption,
    LegendClickEvent,
} from '@/dashboards/TitleDashboard/types';
import EChartsReact from 'echarts-for-react';
import { EChartsReactProps } from 'echarts-for-react/lib/types';
import { Ref, forwardRef, memo } from 'react';

type SimpleChartProps = Omit<EChartsReactProps, 'option'> & {
    $shouldExpand?: boolean;
    className?: string;
    'data-testid'?: string;
};

export const BaseChart = memo(
    forwardRef(
        (
            {
                onLegendChange,
                theme: theirTheme,
                ...props
            }: SimpleChartProps & {
                onLegendChange?: (params: LegendClickEvent) => void;
                option: EChartsOption;
                theme?: Record<string, any>;
            },
            ref: Ref<EChartsReact>,
        ) => {
            const { theme } = useChartsContext();
            return (
                <EChartsReact
                    theme={{ ...theme, ...(theirTheme ?? {}) }}
                    data-testid={props['data-testid']}
                    className={props.className}
                    style={
                        props.$shouldExpand
                            ? {
                                  minHeight: 'inherit',
                                  height: '100%',
                                  width: '100%',
                              }
                            : {
                                  minHeight: 'inherit',
                                  // height defaults to 300px
                                  height: '300px',
                                  width: '100%',
                              }
                    }
                    ref={ref}
                    onEvents={
                        onLegendChange
                            ? {
                                  legendselectchanged: onLegendChange,
                              }
                            : undefined
                    }
                    notMerge
                    {...props}
                />
            );
        },
    ),
);
